/** Quick scope filter: "All" plus one pill per scope code. Multi-select; All clears. */
export default function ScopePills({ options = [], value = [], onChange, testId = "scope-pills" }) {
  if (!options.length) return null;
  const cls = (on) => `rounded-full px-2 py-0.5 transition-colors ${
    on ? "bg-[#007BFF]/10 font-semibold text-[#007BFF] dark:bg-blue-950/50 dark:text-blue-300" : "hover:text-gray-900"}`;
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId}>
      <button type="button" onClick={() => onChange([])} data-active={value.length === 0 ? "1" : "0"}
              className={cls(value.length === 0)} data-testid={`${testId}-all`}>All</button>
      {options.map((o) => (
        <button key={o.value} type="button" onClick={() => toggle(o.value)} title={o.value}
                data-active={value.includes(o.value) ? "1" : "0"} className={cls(value.includes(o.value))}
                data-testid={`${testId}-${o.label}`}>
          {o.label}
        </button>
      ))}
    </span>
  );
}
